function setHeaders(headers, user) {
  if (user && user.access_token) {
    return {
      ...headers,
      Authorization: `Bearer ${user.access_token}`
    };
  } else {
    return headers;
  }
}

function getQueryString(
  password,
  sort,
  innerWidth,
  view,
  viewHeight,
  cacheBuster,
  showItems
) {
  return `${
    password && password !== ""
      ? "&password=" + encodeURIComponent(password)
      : ""
  }${sort && sort !== "" ? "&sort=" + sort : ""}${
    innerWidth && innerWidth !== "" ? "&windowWidth=" + innerWidth : ""
  }${view && view !== "" ? "&view=" + view : ""}${
    viewHeight && viewHeight !== "" ? "&viewHeight=" + viewHeight : ""
  }${cacheBuster && cacheBuster !== "" ? "&cb=" + cacheBuster : ""}${
    showItems && showItems !== "" ? "&showItems=" + showItems : ""
  }
  `;
}

export { setHeaders, getQueryString };
